var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('Stories',{attrs:{"stories":_vm.items,"duration":10000,"showOuterContent":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }